import React, { useState } from 'react';
import Button from '../../Button';
import { adminPanelService } from '../../../api/services/AdminPanelService';

const UserActionsForm: React.FC = () => {
  const [userId, setUserId] = useState('');
  const [loading, setLoading] = useState<'delete' | 'send' | null>(null);
  const [message, setMessage] = useState<{ type: 'success' | 'danger'; text: string } | null>(null);

  const handleDelete = async () => {
    if (!userId.trim()) {
      setMessage({ type: 'danger', text: 'User ID giriniz.' });
      return;
    }
    setLoading('delete');
    setMessage(null);
    try {
      const res = await adminPanelService.deleteUser(userId.trim());
      if (res.isSuccess) {
        setMessage({ type: 'success', text: 'Kullanıcı silindi.' });
        setUserId('');
      } else {
        setMessage({ type: 'danger', text: res.message || 'Silme işlemi başarısız.' });
      }
    } catch {
      setMessage({ type: 'danger', text: 'İstek başarısız.' });
    } finally {
      setLoading(null);
    }
  };

  const handleSendActivation = async () => {
    if (!userId.trim()) {
      setMessage({ type: 'danger', text: 'User ID giriniz.' });
      return;
    }
    setLoading('send');
    setMessage(null);
    try {
      const res = await adminPanelService.sendActivationEmail(userId.trim());
      if (res.isSuccess) {
        setMessage({ type: 'success', text: 'Aktivasyon e-postası gönderildi.' });
      } else {
        setMessage({ type: 'danger', text: res.message || 'Gönderim başarısız.' });
      }
    } catch {
      setMessage({ type: 'danger', text: 'İstek başarısız.' });
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h6 className="mb-0">Kullanıcı İşlemleri</h6>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <label className="form-label">User ID (UUID)</label>
          <input
            type="text"
            className="form-control"
            placeholder="örn. 550e8400-e29b-41d4-a716-446655440000"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />
        </div>
        {message && (
          <div className={`alert alert-${message.type} py-2`} role="alert">
            {message.text}
          </div>
        )}
        <div className="d-flex gap-2">
          <Button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
            disabled={loading !== null}
          >
            {loading === 'delete' ? (
              <span className="spinner-border spinner-border-sm me-1" role="status" />
            ) : null}
            Kullanıcıyı Sil
          </Button>
          <Button
            type="button"
            className="btn btn-primary"
            onClick={handleSendActivation}
            disabled={loading !== null}
          >
            {loading === 'send' ? (
              <span className="spinner-border spinner-border-sm me-1" role="status" />
            ) : null}
            Aktivasyon E-postası Gönder
          </Button>
        </div>
      </div>
    </div>
  );
}

export default UserActionsForm;
